export default __webpack_public_path__ + "static/media/ban_left_corner.b7909d08.png";